import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { createElement } from 'react';
import { ksdpComplianceMgmtReadPermission } from '@internal/ksdp-permissions-common';
import { guardKsdpPage } from '@internal/ksdp-permissions-react';
import { CompliancePage } from './components/CompliancePage';
import { CustomComplianceIcon } from './icons/ComplianceIcon';

const complianceManagementPage = PageBlueprint.make({
  name: 'compliance-management',
  params: {
    path: '/compliance-management',
    title: 'Compliance Management',
    icon: createElement(CustomComplianceIcon),
    loader: async () =>
      guardKsdpPage(
        ksdpComplianceMgmtReadPermission,
        createElement(CompliancePage),
      ),
  },
});

export const complianceManagementPlugin = createFrontendPlugin({
  pluginId: 'compliance-management',
  extensions: [complianceManagementPage],
});
